import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-plan',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './plan.component.html',
  styleUrl: './plan.component.scss'
})
export class PlanComponent implements OnInit {
  @Input() planType = 'PeerComparisonBasic';
  @Input() selected = false;
  @Input() highlighted = false;
  @Input() upgrade = false;
  public title?: string;
  public monthlyPrice?: string;
  public annualPrice?: string;
  // public features?: string[];

  public features: Record<string, string[]> = {};
  public featureEntries: [string, string[]][] = [];


  ngOnInit(): void {
    if (this.planType == 'PeerComparisonBasic') {
      this.title = 'Free Plan';
      this.monthlyPrice = '0';
      this.annualPrice = '0';
      this.features["TNational Peer Group"] = [];
      this.features["State Peer Group"] = [];
      this.features["LHA National Peer Group"] = [];
    }

    if (this.planType == 'PeerComparisonStandard') {
      this.title = 'Peer Comparison';
      this.monthlyPrice = '99';
      this.annualPrice = '1000';

      this.features['Aggregate Benchmark Peer Groups'] = [];
      this.features['Custom Peer Groups'] = [];
      this.features['Performance Metrics'] = [];
      this.features['Income/Expense to Market Rate Analysis'] = [];
      this.features['PDF Reports'] = [];

    }
    if (this.planType == 'NonMaturityDepositsStandard') {
      this.title = 'Non-Maturity Deposits';
      this.monthlyPrice = '145';
      this.annualPrice = '1740';
      this.features['Decay Rate Assumptions'] = ["Run off values","Weighted Average Life"];
      this.features['Beta Assumptions'] = ["Multiple rate scenarios "]

    }
    if (this.planType == 'BundleYearly') {
      this.title = 'Peer Comparison + Non-Maturity Deposits';
      this.monthlyPrice = '200';
      this.annualPrice = '2400';

      this.features['All Peer Comparison Features'] = [];
      this.features['All Non-Maturity Deposits features'] = [];

    }
    this.featureEntries = Object.entries(this.features);
  }
}
